import {Navigate, Route, Routes } from "react-router-dom";
import Callback from "../components/auth/Callback";
import Logout from "../components/auth/Logout";
import LogoutCallback from "../components/auth/LogoutCallback";
import SilentRenew from "../components/auth/SilentRenew";
import Menu from "../components/Menu/Menu";
import PingAuthRoute from "./PingAuthRoute";
import GuardedRoute from "./GuardedRoute";
import { useEffect, useState } from "react";
import NotAuthorized from "../components/NotAuthorized/notAuthorized";
import DelayList from "../components/DelayList/DelayList";
import Alert from "../components/Alert/Alert";


export default function AppRoutes() {
    const [alertType, setAlertType] = useState<string>("");
    const [alertMsg, setAlertMessage] = useState<string>("");
    const [page, setPage] = useState<string>("");
    const alertHandler = (page: string, type: string, msg: string, id: number) => {
        setAlertType(type);
        setAlertMessage(msg);
        setPage(page);
      };
    useEffect(() => {
        console.info("Env " + process.env.REACT_APP_ENV);
    
    });  
    
    return (
        <>
            <Menu />
            <div className="ComponentContent">
                <Routes>
                    
                
  
                <Route path="/signin-oidc" element={<Callback/>} />
                <Route path="/" element={<PingAuthRoute />}>
                    <Route element={<GuardedRoute />}>
                        <Route index element={<Navigate to="/DelayList" replace />} />
                        <Route path="/DelayList" element={<DelayList handleAlert={alertHandler}/>} />
                    </Route>
                </Route>
                    <Route path="/logout" element={<Logout/>} />
                    <Route path="/logout/callback" element={<LogoutCallback/>} />
                    <Route path="/silentrenew" element={<SilentRenew/>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                    <Route path="/notauthorized" element={<NotAuthorized/>}/>
                </Routes>
            </div>

           {alertMsg && (
             <div className="ComponentAlerts">
               <Alert page={page} message={alertMsg} type={alertType} onClose={()=>setAlertMessage("")}/>
             </div>
            )}
        </>
    );
}